import Ae, { forwardRef as Ie, createElement as le } from "react";
import { polymorphicFactory as $e, useProps as Me, Text as De } from "@mantine/core";
import Ye from "clsx";
function qe(e, a) {
  if (typeof e != "object" || e === null)
    return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var t = o.call(e, a);
    if (typeof t != "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (a === "string" ? String : Number)(e);
}
function ke(e) {
  var a = qe(e, "string");
  return typeof a == "symbol" ? a : String(a);
}
function We(e, a, o) {
  return a = ke(a), a in e ? Object.defineProperty(e, a, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = o, e;
}
function pe(e, a) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    a && (t = t.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), o.push.apply(o, t);
  }
  return o;
}
function de(e) {
  for (var a = 1; a < arguments.length; a++) {
    var o = arguments[a] != null ? arguments[a] : {};
    a % 2 ? pe(Object(o), !0).forEach(function(t) {
      We(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : pe(Object(o)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }
  return e;
}
function ve(e, a) {
  var o = {};
  for (var t in e)
    o[t] = a(e[t], t);
  return o;
}
var Le = (e, a, o) => {
  for (var t of Object.keys(e)) {
    var c;
    if (e[t] !== ((c = a[t]) !== null && c !== void 0 ? c : o[t]))
      return !1;
  }
  return !0;
}, we = (e) => {
  var a = (o) => {
    var t = e.defaultClassName, c = de(de({}, e.defaultVariants), o);
    for (var f in c) {
      var b, l = (b = c[f]) !== null && b !== void 0 ? b : e.defaultVariants[f];
      if (l != null) {
        var E = l;
        typeof E == "boolean" && (E = E === !0 ? "true" : "false");
        var O = (
          // @ts-expect-error
          e.variantClassNames[f][E]
        );
        O && (t += " " + O);
      }
    }
    for (var [m, _] of e.compoundVariants)
      Le(m, c, e.defaultVariants) && (t += " " + _);
    return t;
  };
  return a.variants = () => Object.keys(e.variantClassNames), a.classNames = {
    get base() {
      return e.defaultClassName.split(" ")[0];
    },
    get variants() {
      return ve(e.variantClassNames, (o) => ve(o, (t) => t.split(" ")[0]));
    }
  }, a;
}, ze = we({ defaultClassName: "_1nmprgt8", variantClassNames: { size: { xl: "_1nmprgt9", lg: "_1nmprgta", md: "_1nmprgtb", sm: "_1nmprgtc", xs: "_1nmprgtd" } }, defaultVariants: {}, compoundVariants: [] }), sr = we({ defaultClassName: "_1nmprgt0", variantClassNames: { size: { h1: "_1nmprgt1", h2: "_1nmprgt2", h3: "_1nmprgt3", h4: "_1nmprgt4", h5: "_1nmprgt5", xl: "_1nmprgt6", md: "_1nmprgt7" } }, defaultVariants: {}, compoundVariants: [] });
const fr = $e((e, a) => {
  const o = Me("Text", {}, e), { size: t = "md", className: c, ...f } = o;
  return /* @__PURE__ */ Ae.createElement(De, { className: Ye(ze({ size: t }), c), ...f });
});
function Fe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fe = { exports: {} }, B = { exports: {} }, P = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ye;
function Ne() {
  if (ye)
    return P;
  ye = 1;
  var e = typeof Symbol == "function" && Symbol.for, a = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, f = e ? Symbol.for("react.profiler") : 60114, b = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, E = e ? Symbol.for("react.async_mode") : 60111, O = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, _ = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, R = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, D = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
  function A(i) {
    if (typeof i == "object" && i !== null) {
      var k = i.$$typeof;
      switch (k) {
        case a:
          switch (i = i.type, i) {
            case E:
            case O:
            case t:
            case f:
            case c:
            case _:
              return i;
            default:
              switch (i = i && i.$$typeof, i) {
                case l:
                case m:
                case M:
                case x:
                case b:
                  return i;
                default:
                  return k;
              }
          }
        case o:
          return k;
      }
    }
  }
  function j(i) {
    return A(i) === O;
  }
  return P.AsyncMode = E, P.ConcurrentMode = O, P.ContextConsumer = l, P.ContextProvider = b, P.Element = a, P.ForwardRef = m, P.Fragment = t, P.Lazy = M, P.Memo = x, P.Portal = o, P.Profiler = f, P.StrictMode = c, P.Suspense = _, P.isAsyncMode = function(i) {
    return j(i) || A(i) === E;
  }, P.isConcurrentMode = j, P.isContextConsumer = function(i) {
    return A(i) === l;
  }, P.isContextProvider = function(i) {
    return A(i) === b;
  }, P.isElement = function(i) {
    return typeof i == "object" && i !== null && i.$$typeof === a;
  }, P.isForwardRef = function(i) {
    return A(i) === m;
  }, P.isFragment = function(i) {
    return A(i) === t;
  }, P.isLazy = function(i) {
    return A(i) === M;
  }, P.isMemo = function(i) {
    return A(i) === x;
  }, P.isPortal = function(i) {
    return A(i) === o;
  }, P.isProfiler = function(i) {
    return A(i) === f;
  }, P.isStrictMode = function(i) {
    return A(i) === c;
  }, P.isSuspense = function(i) {
    return A(i) === _;
  }, P.isValidElementType = function(i) {
    return typeof i == "string" || typeof i == "function" || i === t || i === O || i === f || i === c || i === _ || i === C || typeof i == "object" && i !== null && (i.$$typeof === M || i.$$typeof === x || i.$$typeof === b || i.$$typeof === l || i.$$typeof === m || i.$$typeof === I || i.$$typeof === D || i.$$typeof === F || i.$$typeof === R);
  }, P.typeOf = A, P;
}
var S = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var me;
function Ve() {
  return me || (me = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, a = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, f = e ? Symbol.for("react.profiler") : 60114, b = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, E = e ? Symbol.for("react.async_mode") : 60111, O = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, _ = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, R = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, D = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
    function A(n) {
      return typeof n == "string" || typeof n == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      n === t || n === O || n === f || n === c || n === _ || n === C || typeof n == "object" && n !== null && (n.$$typeof === M || n.$$typeof === x || n.$$typeof === b || n.$$typeof === l || n.$$typeof === m || n.$$typeof === I || n.$$typeof === D || n.$$typeof === F || n.$$typeof === R);
    }
    function j(n) {
      if (typeof n == "object" && n !== null) {
        var q = n.$$typeof;
        switch (q) {
          case a:
            var U = n.type;
            switch (U) {
              case E:
              case O:
              case t:
              case f:
              case c:
              case _:
                return U;
              default:
                var ce = U && U.$$typeof;
                switch (ce) {
                  case l:
                  case m:
                  case M:
                  case x:
                  case b:
                    return ce;
                  default:
                    return q;
                }
            }
          case o:
            return q;
        }
      }
    }
    var i = E, k = O, J = l, K = b, X = a, G = m, N = t, Z = M, Q = x, z = o, ee = f, Y = c, W = _, V = !1;
    function re(n) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), r(n) || j(n) === E;
    }
    function r(n) {
      return j(n) === O;
    }
    function s(n) {
      return j(n) === l;
    }
    function y(n) {
      return j(n) === b;
    }
    function d(n) {
      return typeof n == "object" && n !== null && n.$$typeof === a;
    }
    function u(n) {
      return j(n) === m;
    }
    function h(n) {
      return j(n) === t;
    }
    function p(n) {
      return j(n) === M;
    }
    function v(n) {
      return j(n) === x;
    }
    function g(n) {
      return j(n) === o;
    }
    function w(n) {
      return j(n) === f;
    }
    function T(n) {
      return j(n) === c;
    }
    function $(n) {
      return j(n) === _;
    }
    S.AsyncMode = i, S.ConcurrentMode = k, S.ContextConsumer = J, S.ContextProvider = K, S.Element = X, S.ForwardRef = G, S.Fragment = N, S.Lazy = Z, S.Memo = Q, S.Portal = z, S.Profiler = ee, S.StrictMode = Y, S.Suspense = W, S.isAsyncMode = re, S.isConcurrentMode = r, S.isContextConsumer = s, S.isContextProvider = y, S.isElement = d, S.isForwardRef = u, S.isFragment = h, S.isLazy = p, S.isMemo = v, S.isPortal = g, S.isProfiler = w, S.isStrictMode = T, S.isSuspense = $, S.isValidElementType = A, S.typeOf = j;
  }()), S;
}
var be;
function Re() {
  return be || (be = 1, process.env.NODE_ENV === "production" ? B.exports = Ne() : B.exports = Ve()), B.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var te, he;
function Ue() {
  if (he)
    return te;
  he = 1;
  var e = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function t(f) {
    if (f == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(f);
  }
  function c() {
    try {
      if (!Object.assign)
        return !1;
      var f = new String("abc");
      if (f[5] = "de", Object.getOwnPropertyNames(f)[0] === "5")
        return !1;
      for (var b = {}, l = 0; l < 10; l++)
        b["_" + String.fromCharCode(l)] = l;
      var E = Object.getOwnPropertyNames(b).map(function(m) {
        return b[m];
      });
      if (E.join("") !== "0123456789")
        return !1;
      var O = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        O[m] = m;
      }), Object.keys(Object.assign({}, O)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return te = c() ? Object.assign : function(f, b) {
    for (var l, E = t(f), O, m = 1; m < arguments.length; m++) {
      l = Object(arguments[m]);
      for (var _ in l)
        a.call(l, _) && (E[_] = l[_]);
      if (e) {
        O = e(l);
        for (var C = 0; C < O.length; C++)
          o.call(l, O[C]) && (E[O[C]] = l[O[C]]);
      }
    }
    return E;
  }, te;
}
var ne, ge;
function ue() {
  if (ge)
    return ne;
  ge = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ne = e, ne;
}
var oe, Te;
function Ce() {
  return Te || (Te = 1, oe = Function.call.bind(Object.prototype.hasOwnProperty)), oe;
}
var ae, Ee;
function Be() {
  if (Ee)
    return ae;
  Ee = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var a = ue(), o = {}, t = Ce();
    e = function(f) {
      var b = "Warning: " + f;
      typeof console < "u" && console.error(b);
      try {
        throw new Error(b);
      } catch {
      }
    };
  }
  function c(f, b, l, E, O) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in f)
        if (t(f, m)) {
          var _;
          try {
            if (typeof f[m] != "function") {
              var C = Error(
                (E || "React class") + ": " + l + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw C.name = "Invariant Violation", C;
            }
            _ = f[m](b, m, E, l, null, a);
          } catch (M) {
            _ = M;
          }
          if (_ && !(_ instanceof Error) && e(
            (E || "React class") + ": type specification of " + l + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof _ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), _ instanceof Error && !(_.message in o)) {
            o[_.message] = !0;
            var x = O ? O() : "";
            e(
              "Failed " + l + " type: " + _.message + (x ?? "")
            );
          }
        }
    }
  }
  return c.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, ae = c, ae;
}
var ie, Oe;
function He() {
  if (Oe)
    return ie;
  Oe = 1;
  var e = Re(), a = Ue(), o = ue(), t = Ce(), c = Be(), f = function() {
  };
  process.env.NODE_ENV !== "production" && (f = function(l) {
    var E = "Warning: " + l;
    typeof console < "u" && console.error(E);
    try {
      throw new Error(E);
    } catch {
    }
  });
  function b() {
    return null;
  }
  return ie = function(l, E) {
    var O = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function _(r) {
      var s = r && (O && r[O] || r[m]);
      if (typeof s == "function")
        return s;
    }
    var C = "<<anonymous>>", x = {
      array: D("array"),
      bigint: D("bigint"),
      bool: D("boolean"),
      func: D("function"),
      number: D("number"),
      object: D("object"),
      string: D("string"),
      symbol: D("symbol"),
      any: F(),
      arrayOf: A,
      element: j(),
      elementType: i(),
      instanceOf: k,
      node: G(),
      objectOf: K,
      oneOf: J,
      oneOfType: X,
      shape: Z,
      exact: Q
    };
    function M(r, s) {
      return r === s ? r !== 0 || 1 / r === 1 / s : r !== r && s !== s;
    }
    function R(r, s) {
      this.message = r, this.data = s && typeof s == "object" ? s : {}, this.stack = "";
    }
    R.prototype = Error.prototype;
    function I(r) {
      if (process.env.NODE_ENV !== "production")
        var s = {}, y = 0;
      function d(h, p, v, g, w, T, $) {
        if (g = g || C, T = T || v, $ !== o) {
          if (E) {
            var n = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw n.name = "Invariant Violation", n;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var q = g + ":" + v;
            !s[q] && // Avoid spamming the console because they are often not actionable except for lib authors
            y < 3 && (f(
              "You are manually calling a React.PropTypes validation function for the `" + T + "` prop on `" + g + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), s[q] = !0, y++);
          }
        }
        return p[v] == null ? h ? p[v] === null ? new R("The " + w + " `" + T + "` is marked as required " + ("in `" + g + "`, but its value is `null`.")) : new R("The " + w + " `" + T + "` is marked as required in " + ("`" + g + "`, but its value is `undefined`.")) : null : r(p, v, g, w, T);
      }
      var u = d.bind(null, !1);
      return u.isRequired = d.bind(null, !0), u;
    }
    function D(r) {
      function s(y, d, u, h, p, v) {
        var g = y[d], w = Y(g);
        if (w !== r) {
          var T = W(g);
          return new R(
            "Invalid " + h + " `" + p + "` of type " + ("`" + T + "` supplied to `" + u + "`, expected ") + ("`" + r + "`."),
            { expectedType: r }
          );
        }
        return null;
      }
      return I(s);
    }
    function F() {
      return I(b);
    }
    function A(r) {
      function s(y, d, u, h, p) {
        if (typeof r != "function")
          return new R("Property `" + p + "` of component `" + u + "` has invalid PropType notation inside arrayOf.");
        var v = y[d];
        if (!Array.isArray(v)) {
          var g = Y(v);
          return new R("Invalid " + h + " `" + p + "` of type " + ("`" + g + "` supplied to `" + u + "`, expected an array."));
        }
        for (var w = 0; w < v.length; w++) {
          var T = r(v, w, u, h, p + "[" + w + "]", o);
          if (T instanceof Error)
            return T;
        }
        return null;
      }
      return I(s);
    }
    function j() {
      function r(s, y, d, u, h) {
        var p = s[y];
        if (!l(p)) {
          var v = Y(p);
          return new R("Invalid " + u + " `" + h + "` of type " + ("`" + v + "` supplied to `" + d + "`, expected a single ReactElement."));
        }
        return null;
      }
      return I(r);
    }
    function i() {
      function r(s, y, d, u, h) {
        var p = s[y];
        if (!e.isValidElementType(p)) {
          var v = Y(p);
          return new R("Invalid " + u + " `" + h + "` of type " + ("`" + v + "` supplied to `" + d + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return I(r);
    }
    function k(r) {
      function s(y, d, u, h, p) {
        if (!(y[d] instanceof r)) {
          var v = r.name || C, g = re(y[d]);
          return new R("Invalid " + h + " `" + p + "` of type " + ("`" + g + "` supplied to `" + u + "`, expected ") + ("instance of `" + v + "`."));
        }
        return null;
      }
      return I(s);
    }
    function J(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? f(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : f("Invalid argument supplied to oneOf, expected an array.")), b;
      function s(y, d, u, h, p) {
        for (var v = y[d], g = 0; g < r.length; g++)
          if (M(v, r[g]))
            return null;
        var w = JSON.stringify(r, function($, n) {
          var q = W(n);
          return q === "symbol" ? String(n) : n;
        });
        return new R("Invalid " + h + " `" + p + "` of value `" + String(v) + "` " + ("supplied to `" + u + "`, expected one of " + w + "."));
      }
      return I(s);
    }
    function K(r) {
      function s(y, d, u, h, p) {
        if (typeof r != "function")
          return new R("Property `" + p + "` of component `" + u + "` has invalid PropType notation inside objectOf.");
        var v = y[d], g = Y(v);
        if (g !== "object")
          return new R("Invalid " + h + " `" + p + "` of type " + ("`" + g + "` supplied to `" + u + "`, expected an object."));
        for (var w in v)
          if (t(v, w)) {
            var T = r(v, w, u, h, p + "." + w, o);
            if (T instanceof Error)
              return T;
          }
        return null;
      }
      return I(s);
    }
    function X(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && f("Invalid argument supplied to oneOfType, expected an instance of array."), b;
      for (var s = 0; s < r.length; s++) {
        var y = r[s];
        if (typeof y != "function")
          return f(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(y) + " at index " + s + "."
          ), b;
      }
      function d(u, h, p, v, g) {
        for (var w = [], T = 0; T < r.length; T++) {
          var $ = r[T], n = $(u, h, p, v, g, o);
          if (n == null)
            return null;
          n.data && t(n.data, "expectedType") && w.push(n.data.expectedType);
        }
        var q = w.length > 0 ? ", expected one of type [" + w.join(", ") + "]" : "";
        return new R("Invalid " + v + " `" + g + "` supplied to " + ("`" + p + "`" + q + "."));
      }
      return I(d);
    }
    function G() {
      function r(s, y, d, u, h) {
        return z(s[y]) ? null : new R("Invalid " + u + " `" + h + "` supplied to " + ("`" + d + "`, expected a ReactNode."));
      }
      return I(r);
    }
    function N(r, s, y, d, u) {
      return new R(
        (r || "React class") + ": " + s + " type `" + y + "." + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + u + "`."
      );
    }
    function Z(r) {
      function s(y, d, u, h, p) {
        var v = y[d], g = Y(v);
        if (g !== "object")
          return new R("Invalid " + h + " `" + p + "` of type `" + g + "` " + ("supplied to `" + u + "`, expected `object`."));
        for (var w in r) {
          var T = r[w];
          if (typeof T != "function")
            return N(u, h, p, w, W(T));
          var $ = T(v, w, u, h, p + "." + w, o);
          if ($)
            return $;
        }
        return null;
      }
      return I(s);
    }
    function Q(r) {
      function s(y, d, u, h, p) {
        var v = y[d], g = Y(v);
        if (g !== "object")
          return new R("Invalid " + h + " `" + p + "` of type `" + g + "` " + ("supplied to `" + u + "`, expected `object`."));
        var w = a({}, y[d], r);
        for (var T in w) {
          var $ = r[T];
          if (t(r, T) && typeof $ != "function")
            return N(u, h, p, T, W($));
          if (!$)
            return new R(
              "Invalid " + h + " `" + p + "` key `" + T + "` supplied to `" + u + "`.\nBad object: " + JSON.stringify(y[d], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(r), null, "  ")
            );
          var n = $(v, T, u, h, p + "." + T, o);
          if (n)
            return n;
        }
        return null;
      }
      return I(s);
    }
    function z(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !r;
        case "object":
          if (Array.isArray(r))
            return r.every(z);
          if (r === null || l(r))
            return !0;
          var s = _(r);
          if (s) {
            var y = s.call(r), d;
            if (s !== r.entries) {
              for (; !(d = y.next()).done; )
                if (!z(d.value))
                  return !1;
            } else
              for (; !(d = y.next()).done; ) {
                var u = d.value;
                if (u && !z(u[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ee(r, s) {
      return r === "symbol" ? !0 : s ? s["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && s instanceof Symbol : !1;
    }
    function Y(r) {
      var s = typeof r;
      return Array.isArray(r) ? "array" : r instanceof RegExp ? "object" : ee(s, r) ? "symbol" : s;
    }
    function W(r) {
      if (typeof r > "u" || r === null)
        return "" + r;
      var s = Y(r);
      if (s === "object") {
        if (r instanceof Date)
          return "date";
        if (r instanceof RegExp)
          return "regexp";
      }
      return s;
    }
    function V(r) {
      var s = W(r);
      switch (s) {
        case "array":
        case "object":
          return "an " + s;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + s;
        default:
          return s;
      }
    }
    function re(r) {
      return !r.constructor || !r.constructor.name ? C : r.constructor.name;
    }
    return x.checkPropTypes = c, x.resetWarningCache = c.resetWarningCache, x.PropTypes = x, x;
  }, ie;
}
var se, _e;
function Je() {
  if (_e)
    return se;
  _e = 1;
  var e = ue();
  function a() {
  }
  function o() {
  }
  return o.resetWarningCache = a, se = function() {
    function t(b, l, E, O, m, _) {
      if (_ !== e) {
        var C = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw C.name = "Invariant Violation", C;
      }
    }
    t.isRequired = t;
    function c() {
      return t;
    }
    var f = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: c,
      element: t,
      elementType: t,
      instanceOf: c,
      node: t,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: o,
      resetWarningCache: a
    };
    return f.PropTypes = f, f;
  }, se;
}
if (process.env.NODE_ENV !== "production") {
  var Ke = Re(), Xe = !0;
  fe.exports = He()(Ke.isElement, Xe);
} else
  fe.exports = Je()();
var Ge = fe.exports;
const L = /* @__PURE__ */ Fe(Ge);
var Ze = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, Qe = Object.defineProperty, er = Object.defineProperties, rr = Object.getOwnPropertyDescriptors, H = Object.getOwnPropertySymbols, xe = Object.prototype.hasOwnProperty, je = Object.prototype.propertyIsEnumerable, Pe = (e, a, o) => a in e ? Qe(e, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[a] = o, Se = (e, a) => {
  for (var o in a || (a = {}))
    xe.call(a, o) && Pe(e, o, a[o]);
  if (H)
    for (var o of H(a))
      je.call(a, o) && Pe(e, o, a[o]);
  return e;
}, tr = (e, a) => er(e, rr(a)), nr = (e, a) => {
  var o = {};
  for (var t in e)
    xe.call(e, t) && a.indexOf(t) < 0 && (o[t] = e[t]);
  if (e != null && H)
    for (var t of H(e))
      a.indexOf(t) < 0 && je.call(e, t) && (o[t] = e[t]);
  return o;
}, ur = (e, a, o) => {
  const t = Ie(
    (c, f) => {
      var b = c, { color: l = "currentColor", size: E = 24, stroke: O = 2, children: m } = b, _ = nr(b, ["color", "size", "stroke", "children"]);
      return le(
        "svg",
        Se(tr(Se({
          ref: f
        }, Ze), {
          width: E,
          height: E,
          stroke: l,
          strokeWidth: O,
          className: `tabler-icon tabler-icon-${e}`
        }), _),
        [...o.map(([C, x]) => le(C, x)), ...m || []]
      );
    }
  );
  return t.propTypes = {
    color: L.string,
    size: L.oneOfType([L.string, L.number]),
    stroke: L.oneOfType([L.string, L.number])
  }, t.displayName = `${a}`, t;
};
export {
  fr as T,
  we as a,
  ur as c,
  Fe as g,
  sr as t
};
